import React from 'react';

import { AppBar, Box, Toolbar } from '@mui/material';

import { DisplayUser } from '~/components/DisplayUser';
import { NissanIcon } from '~/components/icons';
import { SubaruLogo } from '~/components/icons';
import { SITE_CLIENT } from '~/env';

import './LogoHeader.css';

interface IAppHeader {
  children?: React.ReactNode;
}

export const LogoHeader: React.FC<IAppHeader> = (props) => {
  const { children } = props;
  return (
    <AppBar position="relative" sx={{ mb: 1 }}>
      <Toolbar>
        <Box className="LogoHeader__space" />
        <Box sx={{ display: 'flex' }} className="LogoHeader__body">
          {(SITE_CLIENT!=='Subaru') && 
            <NissanIcon sx={{ width: 54, height: 45, ml: '20px' }} />
          }
          {(SITE_CLIENT==='Subaru') &&   
            <SubaruLogo sx={{ width: 200, height: 45, ml: '20px' }} />
          }  
          <Box sx={{ display: 'flex', justifyContent: 'left', flexGrow: 1 }}>
            {children}
          </Box>
        </Box>
        <Box className="LogoHeader__space" />
        <DisplayUser />
      </Toolbar>
    </AppBar>
  );
};
